import {$subscriber, cr} from 'fire-wind-water';
import {componentHover} from '../message/hover';
import {renderComponents, destroyCarousel} from '../../components';
import {SK_CMS_DATA, $renderComponent, $renderComponentFn} from './data';
import {updateContainer, splitContainer} from './container';
import {backToTop} from './dom';

const arts = window.arts;
const render = window.render;
export function $stemplateAddRender(str, type, fn) {
  if (!$renderComponentFn[type]) {
    $renderComponentFn[type] = {
      pc: arts[type].pc,
      wap: arts[type].wap
    };
  }
  $renderComponentFn[type][str] = fn;
  if (cr.isString(type)) {
    $renderComponent[`RENDER_${type}`] = (d, t) => {
      return render.renderAdd(d, t, $renderComponentFn[type].pc, $renderComponentFn[type].wap);
    };
    $renderComponent[`RENDER_${type}_UPDATE`] = (d, t) => {
      return render.renderUpdate(d, t, $renderComponentFn[type].pc, $renderComponentFn[type].wap);
    };
  }
}

export function renderTemplate(res) {
  cr.each(res, (o, d) => {
    let str = '';
    const dom = document.getElementById(d) || document.getElementById('sk-cms-main');
    o.sort((a, b) => {
      return a.historyOrderId - b.historyOrderId;
    });
    cr.each(o, (m) => {
      const s1 = `RENDER_${m.type}`;
      const renderAdd = $renderComponent[s1] || render[s1];
      str += renderAdd(cr.isPlainObject(m.historyContent) ? m.historyContent : m.content, m.category);
    });
    if (dom) {
      dom.innerHTML = str;
    }
  });
  componentHover();
}

export function renderComponent(data, type) {
  const s2 = `RENDER_${data.type}_UPDATE`;
  const renderUpdate = $renderComponent[s2] || render[s2];
  const condom = document.getElementById(data.container) || document.getElementById('sk-cms-main');
  if (!renderUpdate(data, type) && condom) {
    renderTemplate(SK_CMS_DATA.container);
    backToTop(data);
  } else {
    componentHover();
  }
}

$subscriber.on('scms-template', (data) => {
  console.log('template', data);
  splitContainer(data.data);
  renderTemplate(SK_CMS_DATA.container);
  renderComponents();
  $subscriber.emit('s-load-components', data.data);
  $subscriber.emit('stemplate-render', SK_CMS_DATA);
});

$subscriber.on('scms-component', (res) => {
  console.log('component', res);
  const data = res.data.content;
  data.orderId = res.data.index;
  data.historyOrderId = res.data.index;
  updateContainer(res.data);
  renderComponent(data, res.data.category);
  renderComponents();
  $subscriber.emit('s-load-components', SK_CMS_DATA.ys.template);
  $subscriber.emit('stemplate-render', SK_CMS_DATA);
});

$subscriber.on('scms-component-delete', (res) => {
  SK_CMS_DATA.components[res.data] = null;
  destroyCarousel(res);
  $subscriber.emit('stemplate-render', SK_CMS_DATA);
});

$subscriber.on('stemplate-container', (res) => {
  SK_CMS_DATA.mainContainer = res;
});
